import React from 'react';
import AssignCertification from './AssignCertification.js';
import DatePickerDropdown from './DatePickerDropdown.js';
import moment from 'moment';
import '../App.css';
import config from '.././config.json';
import $ from 'jquery';
import {
    Form, Input, Select, Checkbox,
    Steps, DatePicker, Modal, Table, Icon, Menu, Alert, Radio, Row, Col, Spin, Card
} from 'antd';
import usStates from '../usStates';
const Step = Steps.Step;
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;
//Columns for selected table
const columnsSelect = [
    {
        title: 'Certification',
        dataIndex: 'Name',
        width: '25%',
    },
    {
        title: 'Category',
        dataIndex: 'CategoryName',
        width: '15%',
    },
    {
        title: 'Number of Years Valid',
        dataIndex: 'NumYearsValid',
        width: '10%',
    },
    {
        title: 'Start Date',
        dataIndex: 'StartDate',
        width: '30%',
    },
];

//Form Layouts
const columnsExtClass = [{
    title: 'Certification',
    dataIndex: 'Name',
    key: 'Name',
}
];

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};

const shortFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 4 },
        sm: { span: 3 },
    },
};

const midFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 6,
        },
    },
};
//
class AssignCertificationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state.student = {
            Id: -1, FirstName: '', MiddleInitial: '', LastName: '', DLN: '', DateofBirth: '',
            StreetAddress: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '', TechID: 'To be assigned'
        };
        this.state.employer = {
            Id: -1, CompanyName: '', Address: '', State: 'ND',
            City: '', ZipCode: '', PhoneNumber: '', Email: ''
        };

        this.certify = { student: this.state.student, employer: this.state.employer };
        this.DobUser = '';
        this.employerList = [];
        this.employerDisplayList = [];
        this.companydropdown = '';
        this.userButtton = "Already Certified before!"

        // State drorpdown
        this.stateList = usStates.listofUSstates();
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallemployer`,
        })
            .done((data) => {
                this.employerList = data;
                for (let i = 0; i < data.length; i++) {
                    var optDis = data[i].CompanyName + ", " + data[i].City + " (" + data[i].State + ")";
                    this.employerDisplayList.push(
                        <Option key={data[i].Id}>{optDis}</Option>
                    );
                }

                this.employerDisplayList.push(
                    <Option key="Other">Other</Option>
                );

            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });

    }
    //function to get system name from url
    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    // State variables
    state = ({
        current: 0,
        filterSystem: "All",
        currentMenu: "Yes",
        userVisible: false,
        //certificationData: [],
        classData: [],
        filledMenuDisplay: false,
        confirmDirty: '',
        certificationDataKeys: [],
        inputControl: true,
        emailValidatorUser: '',
        emailValidatorInfo: '',
        emailValidatorEmployer: '',
        loading: false,
        visibleWarning: false,
        tableWarning: [],
        selectedRowKeys: [],
        selectedRows: [],
        existingButton: "Start new registration",
    });

    /**
    *  Renders the transition and steps
    */
    render() {
        const steps = [{
            title: 'Select Certifications',
        },
        {
            title: 'Your Info',
        },
        {
            title: 'Employer Info',
        },
        {
            title: 'Verification',
        }
        ];
        let page = null;
        if (this.state.current === 0) {
            page = this.firstPage();
        }
        else if (this.state.current === 1) {
            page = this.secondPage();
        }
        else if (this.state.current === 2) {
            page = this.thirdPage();
        }
        else if (this.state.current === 3) {
            page = this.fourthPage();
        }
        const { current } = this.state;
        return (
            <div className="color3">
                <Steps current={current}>
                    {steps.map(item =>
                        <Step key={item.title} title={item.title} />
                    )}
                </Steps>
                <div>
                    <Form style={{ marginTop: 20 }}>
                        {page}
                    </Form>
                </div>
                <div className="steps-action">
                    {/*Renders Previous*/}
                    {
                        (this.state.current > 0)
                            ?
                            <button type="submit" className="btn btn-default color2" onClick={() => this.prev()}>Previous</button>
                            :
                            <button type="submit" className="btn btn-default color2" disabled style={{ visibility: "hidden" }}>Previous</button>
                    }
                    {/*Renders Next*/}
                    {
                        this.buttonHandler(steps)
                    }
                    {/*htmlType="submit" size="large"*/}
                    <center><a target="_blank" href='https://forms.nd.gov/231086668767875'>Contact: Technical Certification Program (TCP)</a>&emsp;&emsp;<a target="_blank" href='https://forms.nd.gov/231105789465866'>Contact: Erosion and Sediment Control (ESCC)</a></center>
                </div>
            </div>
        );
    }

    // Display button

    buttonHandler = (steps) => {
        if (this.state.current < steps.length - 1 && (this.state.filledMenuDisplay == true || this.state.current != 1 || this.state.currentMenu == 'No')) {
            return (<button className="btn btn-default" style={{ marginLeft: 10, float: 'right' }} onClick={() => this.next()}>Next</button>);
        }
        else if (this.state.current == 3) {
            return (<button className="btn btn-default" onClick={this.handleSubmit} style={{ float: 'right' }}>Register</button>);

        }
    }

    // Perform tasks when clicked next 
    next() {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const current = this.state.current;
                if (current === 0 && this.state.classData.length < 1) {
                    Modal.error({
                        title: 'Error',
                        content: 'A certification must be selected.',
                    });
                    return;
                }

                this.setState({
                    current: current + 1,
                });
                if (current === 1 && values.dob != null) {
                    const student = this.state.student;
                    student.FirstName = this.capitalize(values.fname);
                    student.LastName = this.capitalize(values.lname);
                    student.MiddleInitial = values.mname;
                    student.DLN = values.dln;
                    student.StreetAddress = values.street;
                    student.State = values.state;
                    student.City = values.city;
                    student.ZipCode = values.zipcode;
                    student.PhoneNumber = values.phone;
                    student.Email = values.email;
                    student.DateofBirth = values.dob;
                    this.setState({
                        student
                    });

                    if (this.companydropdown !== '') {
                        this.setState({
                            inputControl: false
                        });
                    }
                }

                if (current === 2) {
                    const employer = this.state.employer;
                    employer.CompanyName = values.company;
                    employer.Address = values.streetCompany;
                    employer.State = values.stateCompany;
                    employer.City = values.cityCompany;
                    employer.ZipCode = values.zipcodeCompany;
                    employer.PhoneNumber = values.phoneCompany;
                    employer.Email = values.emailCompany;
                    this.setState({
                        employer
                    });
                }
            }
        });
    }

    // Perform Tasks when clicked previous
    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
        if (current === 1) {
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    const employer = this.state.employer;
                    employer.CompanyName = values.company;
                    employer.Address = values.streetCompany;
                    employer.State = values.stateCompany;
                    employer.City = values.cityCompany;
                    employer.ZipCode = values.zipcodeCompany;
                    employer.PhoneNumber = values.phoneCompany;
                    employer.Email = values.emailCompany;
                    this.setState({
                        employer
                    });
                }
            });
        }
    }

    /**
    * First Page - Select classes
    */
    firstPage = () => {
        const { getFieldDecorator } = this.props.form;
        /*------------------------------------------ Register for some Classes! ------------------------------------------*/
        return (
            <div className='forms'>
                <FormItem
                    label="Certification System"
                    {...formItemLayout}>
                    {getFieldDecorator('system', {
                        initialValue: "All"
                    })(
                        <Select
                            onChange={this.handleSelectChangeSystem}>
                            <Option value="All">All</Option>
                            <Option value="TCP">TCP</Option>
                            <Option value="ESCC">ESCC</Option>
                        </Select>
                    )}
                </FormItem>
                <FormItem>
                    <AssignCertification systemFilter={this.state.filterSystem} getData={this.setSelectedData} renderData={this.state.certificationDataKeys} />
                </FormItem>
                <Table rowKey="Id" columns={columnsSelect} dataSource={this.state.classData} size="small" bordered />
                <br />
            </div>
        );
    }

    /**
    * Second transtion handler
    */
    secondPage = () => {
        const { getFieldDecorator } = this.props.form;
        /*------------------------------------------ User Login Page ------------------------------------------*/
        return (
            <div>
                {this.getMenuData()}
            </div>
        );
    }

    //Second page table button controller

    onSelectChange = (selectedRowKeys, selectedRows) => {

        if (selectedRows.length == 1) {
            console.log("here");
            this.setState({
                selectedRowKeys: selectedRowKeys,
                selectedRows: selectedRows,
                existingButton: "Submit"
            });
        }
        else if (selectedRows.length < 1) {
            this.setState({
                selectedRowKeys: selectedRowKeys,
                selectedRows: selectedRows,
                existingButton: "Start new registration"
            });
        }
        else {
            Modal.error({
                title: 'Error',
                content: 'Only one student can be selected.',
            });

        }

    };

    // Handles existing user selection
    onContinue = () => {
        console.log(this.state.selectedRows);
        this.setState({ visibleWarning: false });
        if (this.state.selectedRows.length == 1) {
            this.existingUser = { TechID: this.state.selectedRows[0].TechID, LastName: this.state.selectedRows[0].LastName };
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/registration/searchtech`,
                data: this.existingUser
            })
                .done((data) => {
                    this.existingUserData = data;
                    console.log(data);
                    this.setState({
                        student: data.student,
                        employer: data.employer,
                        currentMenu: "No"
                    });
                    this.setState({
                        userVisible: false,
                        filledMenuDisplay: true
                    });
                    this.companydropdown = this.existingUserData.employer.CompanyName;
                    this.userButtton = "Wrong Info!"
                })
                .fail((jqXhr) => {
                    console.log("Failed to search");
                });
        }

        else {
            this.setState({
                currentMenu: "No"
            });
        }
    }

    /**
        * Display menu for existing/new user
        */
    getMenuData() {
        if (this.state.currentMenu === 'Yes') {
            const { getFieldDecorator } = this.props.form;
            const { selectedRowKeys, selectedRows } = this.state;
            const rowSelection = {
                selectedRowKeys,
                selectedRows,
                onChange: this.onSelectChange,
            };
            const columnWarning = [
                {
                    title: 'First Name',
                    dataIndex: 'FirstName',
                },
                {
                    title: 'Middle I',
                    dataIndex: 'MiddleInitial',
                },
                {
                    title: 'Last Name',
                    dataIndex: 'LastName',
                },
                {
                    title: 'Email',
                    dataIndex: 'Email',
                },
                {
                    title: 'Tech ID',
                    dataIndex: 'TechID',
                },
                {
                    title: 'Address',
                    dataIndex: 'Address',
                    render: (text, record, index) => {
                        var add = 'Not Available';
                        if (record.StreetAddress) {
                            add = record.StreetAddress + ', ' + record.City + ' (' + record.State + ')';
                        }
                        return (
                            <div>{add}</div>
                        );
                    },

                },
                {
                    title: 'Employer',
                    dataIndex: 'CompanyName',
                    render: (text, record, index) => {
                        let emp = 'Not Available';
                        if (record.CompanyName) {
                            emp = record.CompanyName + ", " + record.EmployerCity + " (" + record.EmployerState + ")"
                        }
                        return (
                            <div>{emp}</div>
                        );
                    },
                },

            ];
            if (this.state.filledMenuDisplay === false) {
                return (
                    <div>

                        <Modal
                            visible={this.state.userVisible}
                            title={this.existingUserName}
                            onOk={this.handleUserYes}
                            onCancel={this.handleUserCancel}
                            footer={[
                                <button className="btn btn-default" key="back" size="large" onClick={this.handleUserCancel}>No</button>,
                                <button className="btn btn-default" key="submit" type="primary" size="large" onClick={this.handleUserYes}>Yes</button>,
                            ]}
                        >
                        </Modal>
                        <div style={{ 'textAlign': 'center', }} ><p>To start, please fill the fields in one section only. If you know your Tech ID, please use that section.
                            <b>If you have taken a TCP or ESCC class before, you have a Tech ID.</b>
                            If you do not know it, please search for it by using your last name in the below form. If you do not have a Tech ID, you will be assigned one after registration</p></div>
                        <div>
                            <br />
                            <br />
                            <Card style={{ width: 850 }}>
                                <Row gutter={8}>
                                    <Col span={10} style={{ 'textAlign': 'center', }} >
                                        <FormItem  {...formItemLayout} label="Last Name*">
                                            {getFieldDecorator('lNameEx')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={8} style={{ 'textAlign': 'center', }} >
                                        <FormItem  {...formItemLayout} label="Tech ID">
                                            {getFieldDecorator('techId')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={6} style={{ 'textAlign': 'center', }} >
                                        <button style={{ 'color': 'black', margin: 'auto', display: 'block' }} className="btn btn-default" onClick={() => this.validateExisting()}>Search</button>

                                    </Col>
                                </Row>
                            </Card>
                            <br />
                            {this.state.visibleWarning ? (
                                <div>
                                    If you see your information in the table select that row and continue else click start new registration.
                                    <br />
                                    <br />
                                    < Table rowKey="StudentId" rowSelection={rowSelection} columns={columnWarning} dataSource={this.state.tableWarning} size="small" bordered />

                                    <br />
                                    <button style={{ 'color': 'black', margin: 'auto', display: 'block' }} className="btn btn-default" onClick={() => this.onContinue()}>{this.state.existingButton}</button>
                                </div>
                            ) : <div></div>}
                        </div>

                    </div>
                );
            }
            if (this.state.filledMenuDisplay === true) {
                return (this.getUserData());
            }
        }
        else {
            return (this.getUserData());
        }
    }
    handleEmailValidationUser = (e) => {
        this.setState({
            emailValidatorUser: 'email',
        },
            () => {
                this.props.form.validateFields(['emailEx'], { force: true });
            });

    }

    getDateOfBirth = (date) => {

        this.props.form.setFieldsValue({
            ['DOBEx']: date,
        });
        this.DobUser = date;
    }
    /**
    * Personal Data Entry form
    */
    getDateOfBirthNew = (date) => {

        this.props.form.setFieldsValue({
            ['dob']: date,
        });

    }
    getUserData = () => {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className='forms'>
                {/*------------------------------------------ User Details ------------------------------------------*/}
                <FormItem {...formItemLayout} label="First Name" >
                    {getFieldDecorator('fname', {
                        initialValue: this.state.student.FirstName,
                        rules: [{
                            required: true, message: 'Please input your first name!',
                        }],
                    })(<Input />)}
                </FormItem>
                {/*TODO: Limit one character*/}
                <FormItem {...shortFormItemLayout} label="Middle Initial" >
                    {getFieldDecorator('mname', {
                        initialValue: this.state.student.MiddleInitial,
                        rules: [{
                            required: true, message: 'Please input your middle initial!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem {...formItemLayout} label="Last Name" >
                    {getFieldDecorator('lname', {
                        initialValue: this.state.student.LastName,
                        rules: [{
                            required: true, message: 'Please input your last name!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem {...formItemLayout} label="Tech ID" >
                    {getFieldDecorator('TechID', {
                        initialValue: this.state.student.techId
                    })(<Input disabled />)}
                </FormItem>

                {/*
                    <FormItem {...formItemLayout} label="DLN">
                    {getFieldDecorator('dln', {
                        initialValue: this.state.student.DLN,
                        rules: [{
                            required: true, message: 'Please enter your driver\'s licence number!',
                        }],
                    })(<Input placeholder="Driver's Licence Number" />)}
                </FormItem>
                    */}

                <FormItem
                    {...formItemLayout} label="Date of Birth">
                    {getFieldDecorator('dob', {
                        initialValue: this.state.student.DateofBirth,
                        rules: [{
                            required: true, message: 'Please enter your date of birth!',
                        }],
                    })(

                        <DatePickerDropdown getDOBNew={this.getDateOfBirthNew} sendUserData={this.state.student.DateofBirth} />
                        // <DatePicker format={"MM-DD-YYYY"} onChange={this.onChange} />
                    )}
                </FormItem>
                {/*------------------------------------------ ADDRESS ------------------------------------------*/}
                <FormItem {...formItemLayout} label="Street">
                    {getFieldDecorator('street', {
                        initialValue: this.state.student.StreetAddress,
                        rules: [{
                            required: true, message: 'Please input street!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem {...formItemLayout} label="City" >
                    {getFieldDecorator('city', {
                        initialValue: this.state.student.City,
                        rules: [{
                            required: true, message: 'City',
                        }],
                    })(<Input />)}
                </FormItem>

                <FormItem {...formItemLayout} label="State">
                    {getFieldDecorator('state', {
                        initialValue: this.state.student.State,
                        rules: [
                            { required: true, message: 'Please select your country!' },
                        ],
                    })(
                        <Select
                            showSearch
                            style={{ width: '40%' }}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.stateList}
                        </Select>)}
                </FormItem>

                <FormItem {...midFormItemLayout} label="Zip Code">
                    {getFieldDecorator('zipcode', {
                        initialValue: this.state.student.ZipCode,
                        rules: [{ required: true, message: 'Please input your zip code!' },
                        {
                            validator: this.checkZipCode,
                        }
                        ],
                    })(
                        <Input style={{ width: '100%' }} />
                    )}
                </FormItem>
                {/*------------------------------------------ CONTACT ------------------------------------------*/}
                <FormItem {...formItemLayout} label="Phone Number">
                    {getFieldDecorator('phone', {
                        initialValue: this.state.student.PhoneNumber,
                        rules: [{ required: true, message: 'Please input your phone number!' },
                        {
                            validator: this.checkZipPhone,
                        }],
                    })(
                        <Input style={{ width: '100%' }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout} label="Email">
                    {getFieldDecorator('email', {
                        initialValue: this.state.student.Email,
                        rules: [{
                            type: this.state.emailValidatorInfo, message: 'The input is not a valid e-mail!'
                        }, {
                            required: true, message: 'Please input your email!',
                        }, {
                            validator: this.checkConfirm,
                        }],
                    })(
                        <Input onBlur={this.handleEmailValidation} />
                    )}
                </FormItem>
                {/*
                <FormItem
                    {...formItemLayout}
                    label="Confirm Email"

                >
                    {getFieldDecorator('emailConfirm', {
                        initialValue: this.state.student.Email,
                        rules: [{
                            required: true, message: 'Please confirm your email!',
                        }, {
                            validator: this.checkEmail,
                        }],
                    })(
                        <Input onBlur={this.handleConfirmBlur} />
                    )}
                </FormItem>
                    */}
                {//<FormItem>
                    //    <button type="submit" className="btn btn-default" onClick={() => this.resetData()}>{this.userButtton}</button>
                    //</FormItem>
                }
            </div>
        );
    }

    handleEmailValidation = (e) => {
        this.setState({
            emailValidatorInfo: 'email',
        },
            () => {
                this.props.form.validateFields(['email'], { force: true });
            });

    }

    check = () => {
        this.props.form.validateFields(
            (err) => {
                if (!err) {
                    console.info('success');
                }
            },
        );
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }

    checkZipCode = (rule, value, callback) => {
        const form = this.props.form;
        if (/^\d{5}(-\d{4})?$/.test(value)) {
            callback();
        }
        else
            callback('The value is not valid postal code');
    }

    checkZipPhone = (rule, value, callback) => {
        const form = this.props.form;
        if (/^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(value) || value === '') {
            callback();
        }
        else
            callback('Enter 10 digit phone number!');
    }

    checkEmail = (rule, value, callback) => {
        const form = this.props.form;
        if (this.state.current === 1) {
            if (value && value !== form.getFieldValue('email')) {
                callback('The two email addresses that you entered are inconsistent!');
            } else {
                callback();
            }

        }
        if (this.state.current === 2) {
            if (value && value !== form.getFieldValue('emailCompany')) {
                callback('The two email addresses that you entered are inconsistent!');
            } else {
                callback();
            }

        }


    }
    checkConfirm = (rule, value, callback) => {
        const form = this.props.form;
        if (this.state.current === 1) {
            if (value && this.state.confirmDirty) {
                form.validateFields(['emailConfirm'], { force: true });
            }
            callback();
        }
        if (this.state.current === 2) {
            if (value && this.state.confirmDirty) {
                form.validateFields(['emailConfirmCompany'], { force: true });
            }
            callback();
        }

    }

    resetData = (e) => {
        this.props.form.resetFields();
        this.existingUserData = '';
        this.setState({
            employer: {
                Id: -1, CompanyName: '', Address: '', State: 'ND',
                City: '', ZipCode: '', PhoneNumber: '', Email: ''
            },
            student: {
                Id: -1, FirstName: '', MiddleInitial: '', LastName: '', DLN: '', DateofBirth: '',
                StreetAddress: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '', TechID: 'To be assigned'
            },
            filledMenuDisplay: false,
            currentMenu: 'Yes'
        });
    }

    // Handlers for second page
    validateExisting = () => {
        var email = this.props.form.getFieldValue('emailEx');
        var dob = this.DobUser;
        var techId = this.props.form.getFieldValue('techId') ? this.props.form.getFieldValue('techId') : "-1";
        var LastNameEx = this.capitalize(this.props.form.getFieldValue('lNameEx'));

        if (techId && LastNameEx) {
            this.existingUser = { TechID: techId, LastName: LastNameEx };
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/registration/searchtech`,
                data: this.existingUser
            })
                .done((data) => {
                    if (data.student != null) {
                        this.existingUserName = "Are you " + data.student.FirstName + " " + data.student.LastName + "?";
                        this.setState({
                            userVisible: true,
                        });
                        this.existingUserData = data;
                    }
                    else {
                        this.setState({
                            visibleWarning: true,
                            tableWarning: data
                        });
                    }
                })
                .fail((jqXhr) => {
                    console.log("Failed to search");
                });

        }

        else {
            Modal.error({
                title: 'Error message',
                content: 'Last name is required',
            });

        }

    }

    handleUserYes = () => {
        if (this.existingUserData) {
            this.setState({
                student: this.existingUserData.student,
                employer: this.existingUserData.employer
            });

            this.setState({
                userVisible: false,
                filledMenuDisplay: true
            });
            this.companydropdown = this.existingUserData.employer.CompanyName;
            this.userButtton = "Wrong Info!"
        }

        this.setState({
            userVisible: false,
            currentMenu: "No"
        });


    }
    handleUserCancel = () => {
        this.setState({ userVisible: false });
    }
    /**
    * The employee data entry page.
    */
    thirdPage = () => {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className='forms'>
                <FormItem
                    {...formItemLayout}
                    label="Select Employer from the List"
                >
                    <Select
                        showSearch
                        defaultValue={this.companydropdown}
                        style={{ width: '100%' }}
                        searchPlaceholder="Enter Company Name"
                        optionFilterProp="children"
                        onChange={this.handleChangeEmployer}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        {this.employerDisplayList}
                    </Select>
                </FormItem>
                {/*------------------------------------------ Employer Details ------------------------------------------*/}

                <FormItem {...formItemLayout} label="Company Name">
                    {getFieldDecorator('company', {
                        initialValue: this.state.employer.CompanyName,
                        rules: [{
                            required: true, message: 'Please enter name of the company!',
                        }],
                    })(<Input disabled={this.state.inputControl} />)}
                </FormItem>
                {/*------------------------------------------ EMPLOYER ------------------------------------------*/}

                <FormItem {...formItemLayout} label="Street" >
                    {getFieldDecorator('streetCompany', {
                        initialValue: this.state.employer.Address,
                        rules: [{
                            required: true, message: 'Please input street!',
                        }],
                    })(<Input disabled={this.state.inputControl} />)}
                </FormItem>
                <FormItem {...formItemLayout} label="City" >
                    {getFieldDecorator('cityCompany', {
                        initialValue: this.state.employer.City,
                        rules: [{
                            required: true, message: 'City',
                        }],
                    })(<Input disabled={this.state.inputControl} />)}
                </FormItem>

                <FormItem {...formItemLayout} label="State" >
                    {getFieldDecorator('stateCompany', {
                        initialValue: this.state.employer.State,
                        rules: [
                            { required: true, message: 'Please select your state!' },
                        ],
                    })(
                        <Select
                            disabled={this.state.inputControl}
                            showSearch
                            style={{ width: '40%' }}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.stateList}
                        </Select >)}
                </FormItem>

                <FormItem {...midFormItemLayout} label="Zip Code">
                    {getFieldDecorator('zipcodeCompany', {
                        initialValue: this.state.employer.ZipCode,
                        rules: [{ required: true, message: 'Please input your zip code!' },
                        {
                            validator: this.checkZipCode,
                        }],
                    })(
                        <Input style={{ width: '100%' }} disabled={this.state.inputControl} />
                    )}
                </FormItem>
                {/*------------------------------------------ EMPLOYER Contact ------------------------------------------*/}
                <FormItem {...formItemLayout} label="Phone Number">
                    {getFieldDecorator('phoneCompany', {
                        initialValue: this.state.employer.PhoneNumber,
                        rules: [{
                            validator: this.checkZipPhone,
                        }],
                    })(
                        <Input style={{ width: '100%' }} disabled={this.state.inputControl} />
                    )}
                </FormItem>
                <FormItem {...formItemLayout} label="E-mail" >
                    {getFieldDecorator('emailCompany', {
                        initialValue: this.state.employer.Email,
                        rules: [{
                            type: this.state.emailValidatorEmployer, message: 'The input is not valid e-mail!'
                        }, {
                            validator: this.checkConfirm,
                        }],
                    })(
                        <Input disabled={this.state.inputControl} onBlur={this.handleEmailValidationEmployer} />
                    )}
                </FormItem>
                {/*
                <FormItem
                    {...formItemLayout}
                    label="Confirm Email"

                >
                    {getFieldDecorator('emailConfirmCompany', {
                        initialValue: this.state.employer.Email,
                        rules: [{ required: this.props.form.getFieldValue('emailCompany') !== '', message: 'Please input your zip code!' },
                        {
                            validator: this.checkEmail,
                        }],
                    })(
                        <Input disabled={this.state.inputControl} onBlur={this.handleConfirmBlur} />
                    )}
                </FormItem>
                    */}
            </div>
        );
    }

    handleEmailValidationEmployer = (e) => {
        this.setState({
            emailValidatorEmployer: 'email',
        },
            () => {
                this.props.form.validateFields(['emailCompany'], { force: true });
            });
    }

    handleChangeEmployer = (value) => {
        this.props.form.resetFields();
        this.companydropdown = value;
        for (let i = 0; i < this.employerList.length; i++) {
            if (this.employerList[i].Id == value) {
                this.setState({
                    employer: this.employerList[i]
                });

                this.setState({
                    inputControl: false
                });
                break;
            }
            else {
                this.setState({
                    employer: {
                        Id: -1, CompanyName: '', Address: '', State: '',
                        City: '', ZipCode: '', PhoneNumber: '', Email: ''
                    }
                });
            }

        }
        this.setState({
            inputControl: false
        });

    }
    //Functions used to display verification modal

    fourthPage = () => {
        let date = this.state.student.DateofBirth + "";
        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <span><strong>{this.state.student.FirstName} {this.state.student.MiddleInitial} {this.state.student.LastName}</strong></span>
                    <br /> Date of Birth: {date.split(' ')[0]}
                    <br /> Email: {this.state.student.Email}
                    <br /> Company Name: {this.state.employer.CompanyName}
                    <br /> Tech Id: {this.state.student.TechID}
                    <br />
                    <br />
                    <br />
                    <Table rowKey="Id" columns={columnsSelect} dataSource={this.state.classData} size="small" bordered />
                    <br />
                </Spin>
            </div>);
    }

    //Used to assign the type of system using
    handleSelectChangeSystem = (value) => {
        this.setState({ filterSystem: value });
    }
    //Gets the selected class list
    setSelectedData = (value, keys) => {
        this.setState({
            classData: value,
            certificationDataKeys: keys
        });
    }

    /**
    * Final submit handler
    */
    handleSubmit = (e) => {
        e.preventDefault();
        console.log(JSON.stringify(this.state.classData));

        this.certify = { student: this.state.student, employer: this.state.employer, classData: this.state.classData };

        if (this.state.classData.length != 0) {
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/students/existingclass`,
                data: this.certify
            })
                .done((data) => {
                    var resultExt = this.state.classData;
                    var resultDel = this.state.classData;
                    var arr = [];
                    var datakeyExt = [];
                    for (var i in data) {
                        resultExt = resultExt.filter(function (x) { return x.Id !== data[i]; });
                        var found = resultDel.some(function (el) {
                            return el.Id === data[i];
                        });
                        if (found) { arr.push({ 'Id': resultDel[i].Id, 'Name': resultDel[i].Name }); }
                    }
                    for (var i in resultExt) {
                        datakeyExt.push(resultExt[i].Id);
                    }
                    this.setState({
                        classData: resultExt,
                        certificationDataKeys: datakeyExt
                    });
                    if (Object.keys(arr).length !== 0) {
                        const modal3 = Modal.info({
                            title: "Already registered for these class",
                            content: (<div><p>You are already registered for these classes</p>
                                <Table rowKey="Id" columns={columnsExtClass} dataSource={arr} size="small" bordered />
                                <p>To register for classes you haven't press register again</p>
                            </div>)
                            ,
                            onOk() { },
                        });
                    }

                    else {
                        this.setState({
                            loading: true
                        });
                        $.ajax({
                            type: 'POST',
                            url: `${config.serverUrl}/api/registration/add`,
                            data: this.certify
                        })
                            .done((data) => {
                                console.log(data);
                                const modal = Modal.success({
                                    title: "Class registration successful!",
                                    content: 'Certification Succesful!',
                                    onOk() {
                                        window.location.reload();
                                    }
                                });
                            })
                            .fail((jqXhr) => {
                                console.log('failed to register');
                                this.setState({
                                    loading: false
                                });
                                const modal2 = Modal.error({
                                    title: "Registration failed!",
                                    content: 'Server Error',
                                });
                            });
                    }
                })
                .fail((jqXhr) => {
                    console.log('failed to register');
                });

        }
        else {
            const modal1 = Modal.error({
                title: "Class registration failed!",
                content: 'Select a class to register',
            });
        }
    }

    capitalize(str) {
        if (str)
            return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });

    }


}

const WrappedAssignCertificationForm = Form.create()(AssignCertificationForm);

export default WrappedAssignCertificationForm;



// WEBPACK FOOTER //
// ./src/Registration/AssignCertificationForm.js